import React, { useContext, useEffect } from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Layout from '../../components/Layout/index';
import { HelpdeskIssueFilter, PostFilter, Button } from '../../components';
import { adaptiveContainerPaddingTop, isMobile, navHeight } from '../../utils/responsive';
import { ArticlesParamsContext } from '../../contexts/ArticlesParams/ArticlesParamsContext';
import { EventsParamsContext } from '../../contexts/EventsParams/EventsParamsContext';
import { useHelpdesk } from '../../contexts/HelpdeskContext/HelpdeskContext';
import { ScreenName } from '../../navigation/types';

const PostFilterScreen = ({ route, navigation }) => {
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();

  const fromScreen = route?.params?.fromScreen;

  const {
    getEventsParams,
    setGetEventsParams,
    eventPagination,
    resetInfiniteScroll: resetEventsInfiniteScroll,
  } = useContext(EventsParamsContext);

  const {
    getArticlesParams,
    setGetArticlesParams,
    articlePagination,
    resetInfiniteScroll: resetArticlesInfiniteScroll,
  } = useContext(ArticlesParamsContext);

  const {
    params: helpdeskParams,
    setParams: setHelpdeskParams,
    totalCount: helpdeskTotalCount,
    topics,
    organizations,
    refreshTopicsAndOrganizations,
  } = useHelpdesk();

  const isEventScreen = fromScreen === ScreenName.EventsScreen;
  const isHelpdeskScreen = fromScreen === ScreenName.HelpdeskScreen;

  useEffect(() => {
    if (isHelpdeskScreen) {
      refreshTopicsAndOrganizations();
    }
  }, [isHelpdeskScreen]);

  const resultCount = isHelpdeskScreen
    ? helpdeskTotalCount
    : isEventScreen
      ? eventPagination?.total
      : articlePagination?.total;

  return (
    <Layout isScrollView={!isMobile}>
      <View
        style={{
          marginBottom: 'auto',
          paddingTop: navHeight + insets.top + adaptiveContainerPaddingTop,
        }}
      >
        {isHelpdeskScreen ? (
          <HelpdeskIssueFilter
            params={helpdeskParams}
            paramSetter={setHelpdeskParams}
            showStatus={false}
            totalCount={helpdeskTotalCount}
            clearOnBlur={false}
            topics={topics}
            organizations={organizations}
          />
        ) : (
          <PostFilter
            getPostsParams={isEventScreen ? getEventsParams : getArticlesParams}
            setGetPostsParams={isEventScreen ? setGetEventsParams : setGetArticlesParams}
            resetInfiniteScroll={
              isEventScreen ? resetEventsInfiniteScroll : resetArticlesInfiniteScroll
            }
            screen={fromScreen}
            pagination={isEventScreen ? eventPagination : articlePagination}
          />
        )}
      </View>

      <View
        style={{
          width: '100%',
          bottom: 20,
        }}
      >
        <Button
          text={resultCount < 1 ? t('articles:no_results') : t('articles:view_results')}
          size={'medium'}
          variant={'fill'}
          onPress={() => {
            navigation.goBack();
          }}
          disabled={resultCount < 1}
        />
      </View>
    </Layout>
  );
};

export default PostFilterScreen;
